export interface SelectableDosageType {
  is_active?: number | boolean;
  deleted_at?: string | null;
}

/** Active, non-deleted medicine dosage types only — for selection dropdowns. */
export function filterSelectableDosageTypes<T extends SelectableDosageType>(
  types: T[] | null | undefined
): T[] {
  if (!types?.length) {
    return [];
  }

  return types.filter(
    (type) => !type.deleted_at && type.is_active !== 0 && type.is_active !== false
  );
}
